<template>
  <div>
    <HeaderInnerPage
      class="bg-primary pt-5 pb-5"
      id="politics"
      title="Documentos Pedale"
    >Confira abaixo nosso <strong>Termo de Uso</strong>, <strong>Política de Privacidade</strong> <br /> e <strong>Política de Cancelamento</strong>.
    </HeaderInnerPage>

    <section>
      <b-container>
        <b-row>
          <b-col cols="12">
            <el-tabs
               :tab-position="tabPosition"
               :active-name="page"
               :before-leave="changeTab"
            >
              <el-tab-pane :name="pages.tu" class="mt-4 mt-md-0 pl-0 pl-md-5" label="Termos de Uso">
                <h2 class="mb-3 text-center">Termos de Uso</h2>

                <div
                   class="warp-content"
                   v-loading="loading"
                   v-html="content.tu"></div>

              </el-tab-pane>
              <el-tab-pane :name="pages.pp" class="mt-4 mt-md-0 pl-0 pl-md-5"  label="Política de Privacidade">
                <h2 class="mb-3 text-center">Política de Privacidade</h2>
                 <div
                    class="warp-content"
                    v-loading="loading"
                    v-html="content.pp">
                 </div>
              </el-tab-pane>
              <el-tab-pane :name="pages.al" class="mt-4 mt-md-0 pl-0 pl-md-5" label="Acordo de Locação">
                <h2 class="mb-5 text-center">Acordo de Locação</h2>

                 <div
                    class="warp-content"
                    v-loading="loading"
                    v-html="content.al">
                 </div>

                </el-tab-pane>

            </el-tabs>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>

</template>

<script>
    // @ is an alias to /src
    import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
    import {metaTags} from "@/helpers";
    import SiteService from "@/services/site.service";


    export default {
        name: 'politics',
        metaInfo: metaTags(`Documentos`),
        components: {
            HeaderInnerPage
        },
        data() {
            return {
                tabPosition: 'left',
                Lorem: [],
                page: 'termos-de-uso',
                pages: {
                   tu: 'termos-de-uso',
                   pp: 'politica-de-privacidade',
                   pc: 'politica-de-cancelamento',
                   al: 'acordo-de-locacao',
                },
                content: {
                   tu: null,
                   pp: null,
                   pc: null,
                   al: null,
                },
               loading: true,
               windowWidth: window.innerWidth
            }
        },
       async mounted() {
          await this.getTu()

          window.addEventListener("resize", this.myEventHandler);

          if (this.windowWidth < 996) {
             this.tabPosition = 'top'
             } else {
                this.tabPosition = 'left'
          }


       },
       methods: {
           async getTu() {

              let data;

              if (!this.content.tu) {
                 this.loading = true
                 data = await SiteService.getPolitic('termos-de-uso-pedale')
              }

              if (data) {
                 this.content.tu = data.data;
                 this.loading = false
              }
           },

          async getPp() {
             let data;

             if (!this.content.pp) {
                this.loading = true
                data = await SiteService.getPolitic('politica-de-privacidade')
             }

             if (data) {
                this.content.pp = data.data;
                this.loading = false
             }
          },

          async getAl() {
             let data;

             if (!this.content.al) {
                this.loading = true
                data = await SiteService.getPolitic('acordo-de-locacao')
             }

             if (data) {
                this.content.al = data.data;
                this.loading = false
             }
          },

          async getTpr() {
             let data;

             if (!this.content.tpr) {
                this.loading = true
                data = await SiteService.getPolitic('termos-de-pagamento-e-recebimento')
             }

             if (data) {
                this.content.tpr = data.data;
                this.loading = false
             }
          },

         changeTab(page) {
             switch (page) {
                case this.pages.tu:
                   this.getTu()
                   break
                case this.pages.pp:
                   this.getPp()
                   break
                case this.pages.pc:
                   this.page = this.pages.pc;
                   break
                case this.pages.al:
                   this.getAl()
                   break
                case this.pages.tpr:
                   this.getTpr()
                   break
                default:
                   this.page = this.pages.tu;
             }
          },

          myEventHandler(e) {
             if ( e.target.outerWidth < 996) {
                this.tabPosition = 'top'
             } else {
                this.tabPosition = 'left'
             }
          }


       },


       watch: {
           '$route': {
             handler: function(page) {
                switch (page.params.page) {
                   case this.pages.tu:
                      this.page = this.pages.tu;
                      this.getTu()
                      break
                   case this.pages.pp:
                      this.page = this.pages.pp;
                      this.getPp()
                      break
                   case this.pages.pc:
                      this.page = this.pages.pc;
                      break
                   case this.pages.al:
                      this.page = this.pages.al;
                      this.getAl()
                      break
                   default:
                      this.page = this.pages.tu;
                }
             },
             deep: true,
             immediate: true
         }
       }
    }
</script>

<style lang="scss">

.warp-content {
   min-height: 200px;
}

</style>
